import React, { useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { Button } from "../utils/Button";
import { ReactComponent as FilterIcon } from "../assets/Filter.svg";

import { Products } from "../Components/Products";
import { Filter } from "../Components/Filter";
import { AppContextProvider } from "../App";
import { CallToActionBanner } from "../Components/CallToActionBanner";
import { Footer } from "../Components/Footer/Footer";
import { CiSearch } from "react-icons/ci";
import { MdKeyboardCommandKey } from "react-icons/md";

export const HomeFilter = () => {
  const {
    setFilteredItems,
    filteredItems,
    showFilter,
    setShowFilter,
    clearFilter,
    showAfterApplyFilter,
  } = useContext(AppContextProvider);

  const handleDeleting = (item) => {
    const findItem = filteredItems?.filter((filterItem) => filterItem !== item);
    setFilteredItems(findItem);
  };

  const handleClick = () => {
    setShowFilter(!showFilter);
    document.querySelector("body").style.overflow = "hidden";
  };

  return (
    <>
      <div className="px-6 md:flex md:items-start md:gap-[30px]">
        <div className="flex flex-col">
          <div className="flex mt-6 border rounded-xl">
            <Button att="border w-1/2 border-black " name="Mobile" />
            <Button att="w-1/2 " name="Web" />
          </div>
          <div className="hidden md:block ">
            <Filter />
          </div>
        </div>
        <div className="flex items-center overflow-x-scroll gap-4"></div>

        <div
          onClick={handleClick}
          className="flex justify-center items-center w-full bg-black text-white my-6 space-x-2 py-3 md:hidden rounded-xl"
        >
          <FilterIcon />
          <button className="flex items-center space-x-2">
            <p>Filter</p>{" "}
            <p
              className={
                showAfterApplyFilter & (filteredItems.length > 0) &&
                "bg-white rounded-full text-black h-5 w-5 flex items-center justify-center p-1"
              }
            >
              {showAfterApplyFilter & (filteredItems.length > 0) &&
                filteredItems.length}
            </p>
          </button>
        </div>
        {/* <div className='md:absolute left-[360px] top-2 hidden md:flex space-x-2 items-center bg-[#F2F2F2] rounded-lg px-2 py-2 w-2/5' >
        <CiSearch className='text-xl'/>
        <input className='bg-transparent w-full italic outline-none' type='text' placeholder='Search ux flows, categories or screens'/>
        <div className='bg-white rounded-lg p-1 px-3 flex items-center space-x-1'>
        <MdKeyboardCommandKey/>
        <p>F</p>
        </div>
      </div> */}
        <div>
          {showAfterApplyFilter || filteredItems.length > 0 ? (
            <>
              <p className="font-semibold pb-4">
                ({filteredItems?.length}) user-flows in (12) categories by:
              </p>
              <div className="flex md:flex-wrap md:space-x-0 md:gap-2 items-center space-x-4 overflow-x-scroll hidescroll">
                {filteredItems?.map((item) => {
                  return (
                    <>
                      <p className="bg-black text-white px-4 shrink-0 rounded-lg py-3 flex space-x-4">
                        <p>{item?.name}</p>
                        <span
                          className="cursor-pointer"
                          onClick={() => handleDeleting(item)}
                        >
                          x
                        </span>
                      </p>
                    </>
                  );
                })}
              </div>
              <button
                onClick={() => setFilteredItems([])}
                className="border-2 rounded-lg px-4 py-2 my-4 border-black"
              >
                Clear All
              </button>
            </>
          ) : (
            <p className="font-semibold pb-4">
              (1231) user-flows in (12) categories
            </p>
          )}

          {Products?.map((product) => (
            <div className="" key={uuidv4()}>
              <h1 className="text-2xl">{product.Header}</h1>
              <p className="py-4 text-gray-500">{product.Header2}</p>
              <div className="flex space-x-2 md:justify-end shrink-0">
                <Button
                  iconLeft={product.Icon}
                  att="border w-1/2 space-x-2 text-sm sm:text-md md:w-[200px]"
                  name={product.BtnName1}
                />
                {/* <a href={product.path}> */}

                <Button
                  to={product.path}
                  iconRight={product.Icon2}
                  att="border w-1/2 space-x-2 text-sm sm:text-md md:w-[200px]"
                  name={product.BtnName2}
                />
                {/* </a> */}
              </div>
              <div className="flex items-center gap-[10px] my-6 overflow-x-scroll hidescroll shrink-0">
                {product?.images?.map((img) => (
                  <img
                    alt=""
                    className="rounded-lg object-cover h-[380px] w-full md:w-72"
                    src={img}
                    key={uuidv4()}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
        <div
          className={
            showFilter
              ? "overflow-y-scroll fixed top-0 left-0 w-full bg-white h-full"
              : "hidden"
          }
        >
          <Filter />
        </div>
        <div className="md:hidden">
          <CallToActionBanner />
        </div>
      </div>
    </>
  );
};
